<script>

    import { shipmentStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import ShipmentComponent from './component.shipment.svelte'
    import ChargesShipmentComponent from '../charges/component.charges.shipment.svelte'
    import ChargeCreateComponent from '../charges/component.create.svelte'
    import TrackingComponent from '../trackings/component.tracking.svelte'

    import Modal from '../$components/modal.svelte'
    import Tabs from '../$components/tabs.svelte'

    $: show = $modalStore === 'shipment_modal'

    let tabSelected = 'information'

    const tabOptions = [
        {key: 'information', name: 'Información', icon: 'info-circle'},
        {key: 'tracking', name: 'Tracking', icon: 'map-marker-alt'},
        {key: 'charges', name: 'Cargos', icon: 'file-invoice-dollar'},
    ]

</script>

{#if $shipmentStore}
    <Modal title={ `${ $shipmentStore.provider } | ${ $shipmentStore.service } | ${ $shipmentStore.guide }` } { show } >

        <Tabs bind:selected={tabSelected} options={tabOptions} />

        {#if tabSelected === 'information'}
            <ShipmentComponent />
        {/if}

        {#if tabSelected === 'tracking'}
            <TrackingComponent />
        {/if}

        {#if tabSelected === 'charges' && isPermission($adminStore, 'ShipmentsView.Shipment.Charges')}
            <div class="title is-4">Lista de Cargos y Reembolsos</div>
            <ChargesShipmentComponent />
            <br>
            <div class="title is-4">Agregar</div>
            <ChargeCreateComponent shipmentId={$shipmentStore._id} userId={$shipmentStore.userId} />
        {/if}

    </Modal>
{/if}